// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"9fe9b391","156":"6c9492be","438":"387cc76a","706":"258b89f6","726":"62a977c2","785":"c6fd1fec"}[chunkId] + ".chunk.js";
};